import PropTypes from 'prop-types';

export default {
  contractRequirements: PropTypes.array,
  initiateReservationFlow: PropTypes.func,
  hasAdditionalFieldsError: PropTypes.any,
  setPrerateAdditionalInformation: PropTypes.func,
  handleClose: PropTypes.func,
};
